export default __webpack_public_path__ + "static/media/invoteam.00185b8b.png";